import Backbone from 'backbone';
import 'slick-carousel';

export default Backbone.View.extend({
  initialize: function (options) {
    var self = this;
    self.$content = self.$el;

    self.$content.slick({
      dots: false,
      infinite: false,
      speed: 600,
      slidesToShow: 2,
      arrows: true,
      responsive: [
        {
          breakpoint: ORW.responsiveSizes.medium,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
});
